import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import ReactMarkdown from "react-markdown";

export const SourceTextDialog = ({ open, setOpen, sourceText }) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      slotProps={{
        paper: {
          sx: {
            backgroundImage: "none",
            width: "80% !important",
            maxWidth: "100% !important",
          },
        },
      }}
    >
      <DialogTitle>
        <Typography variant={"h4"}>Source Extract</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant={"body1"}>
          <ReactMarkdown>{sourceText}</ReactMarkdown>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
